"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _LoadingAnimation = require("../LoadingAnimation");
var _Modal = require("../Modal");
var _LoadingModal = require("./LoadingModal.styles");
var _excluded = ["isOpen", "loadingSize", "shouldCloseOnOverlayClick", "children"];
var LoadingModal = function LoadingModal(_ref) {
  var isOpen = _ref.isOpen,
    _ref$loadingSize = _ref.loadingSize,
    loadingSize = _ref$loadingSize === void 0 ? 130 : _ref$loadingSize,
    _ref$shouldCloseOnOve = _ref.shouldCloseOnOverlayClick,
    shouldCloseOnOverlayClick = _ref$shouldCloseOnOve === void 0 ? false : _ref$shouldCloseOnOve,
    children = _ref.children,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_Modal.Modal, (0, _extends2["default"])({
    isOpen: isOpen,
    hasCloseButton: false,
    shouldCloseOnOverlayClick: shouldCloseOnOverlayClick
  }, props), /*#__PURE__*/_react["default"].createElement(_LoadingModal.LoadingModalContainer, null, /*#__PURE__*/_react["default"].createElement(_LoadingAnimation.LoadingAnimation, {
    width: loadingSize,
    height: loadingSize,
    style: {
      margin: '16px'
    }
  }), children && /*#__PURE__*/_react["default"].createElement(_LoadingModal.LoadingModalContent, null, children)));
};
var _default = exports["default"] = LoadingModal;